<template>
  <div v-if="Object.keys(trip_data).length > 0">
    <b-modal
      id="intrepid-trip-info-modal"
      ref="intrepid-trip-info-modal-ref"
      hide-footer
      title="Trip Information"
    >
      <div
        v-if="
          trip_data && trip_data.images && trip_data.images.length > 0 && trip_data.images[0].type === 'banner'
        "
        class="modal-banner-container"
      >
        <img
          :src="trip_data.images[0].href"
          class="vtd-center-image"
        >
        <div class="modal-banner-text">
          {{ trip_data.product.name }}
        </div>
      </div>
      <div>
        <h4 class="mt-3 orange">
          Introduction
        </h4>
        <p
          class="text-left intrepid-breaks"
          v-html="trip_data.product.description"
        />
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Country:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.country }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Start City:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.start_city }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          End City:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.finish_city }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Duration:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.duration }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Trip Style:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.trip_style }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Theme:
        </div>
        <div class="col-md-8">
          <span
            v-for="(theme, index) in trip_data.product.themes"
            :key="index"
          >{{ theme
          }}<span
            v-if="index !== trip_data.product.themes.length - 1"
          >,
          </span></span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Trip Code:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.trip_code }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Group Size:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.group_size }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Physical Rating:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.physical_rating }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Culture Shock:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.culture_shock }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Meals Included:
        </div>
        <div class="col-md-8">
          <span v-if="trip_data.product.breakfast">
            {{ trip_data.product.breakfast }}</span>
          <span
            v-if="
              (trip_data.product.breakfast && trip_data.product.lunch) ||
                (trip_data.product.breakfast && trip_data.product.dinner)
            "
          >,
          </span>
          <span v-if="trip_data.product.lunch">
            {{ trip_data.product.lunch }}</span>
          <span
            v-if="trip_data.product.lunch && trip_data.product.dinner"
          >,
          </span>
          <span v-if="trip_data.product.dinner">
            {{ trip_data.product.dinner }}
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Accommodation:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.accommodation }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Transport:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.transport }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Minimum Age:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.min_age }}
        </div>
      </div>
      <div>
        <h4 class="mt-3 orange">
          Trip Map
        </h4>
        <img
          :src="trip_data.product.map_image"
          class="vtd-center-image"
        >
      </div>
      <h4 class="mt-3 orange">
        Joining the Trip
      </h4>
      <div
        v-for="(note, index) in trip_data.trip_notes"
        :key="`trip_notes_join-${index}`"
      >
        <div v-if="note.joining_point">
          <h5 class="mt-3 vtd-font-weight-bold">
            {{ note.joining_point.title }}
          </h5>
          <p
            v-for="(text, index) in note.joining_point.list.text"
            :key="index"
            class="address my-0 intrepid-breaks"
          >
            {{ text }}
          </p>
        </div>
        <div v-if="note.joining_point_description">
          <h5 class="mt-3 vtd-font-weight-bold">
            {{ note.joining_point_description.title }}
          </h5>
          <p class="intrepid-breaks">
            {{ note.joining_point_description.text }}
          </p>
        </div>
        <div v-if="note.joining_point_instructions">
          <h5 class="mt-3 vtd-font-weight-bold">
            {{ note.joining_point_instructions.title }}
          </h5>
          <p
            class="intrepid-breaks"
          >
            {{ note.joining_point_instructions.text }}
          </p>
        </div>
        <h4 class="mt-3 orange" v-if="note.joining_point_alt">Alternative Joining Point</h4>

          <span v-if="note.joining_point_alt && note.joining_point_alt.list.text && Array.isArray(note.joining_point_alt.list.text)" class="intrepid-breaks">
            <p
              v-for="(text, index) in note.joining_point_alt.list.text"
              :key="index"
          >
            {{ text.trim() }}
          </p>
          </span>
            
        <div v-if="note.joining_point_alt_description">
          <h5 class="mt-3 vtd-font-weight-bold">
            {{ note.joining_point_alt_description.title }}
          </h5>
          <p class="intrepid-breaks">
            {{ note.joining_point_alt_description.text }}
          </p>
          </div>  
        <div v-if="note.joining_point_alt_instructions">
          <h5 class="mt-3 vtd-font-weight-bold">
            {{ note.joining_point_alt_instructions.title }}
          </h5>
          <p class="intrepid-breaks">
            {{ note.joining_point_alt_instructions.text }}
          </p>
          </div>  
      </div>
      <h4 class="mt-3 orange">
        Itinerary
      </h4>
      <div
        v-for="obj in trip_data.itinerary"
        :key="obj.day"
        class="itinerary-container"
      >
        <h6 class="orange">
          Day {{ obj.day }} {{ obj.location }}
        </h6>
        <p>{{ obj.description }}</p>
        <p v-if="obj.summary_information">
          {{ obj.summary_information }}
        </p>
        <div
          v-if="obj.accommodation"
          class="inclusion-container"
        >
          <h5 class="vtd-font-weight-bold">
            Accommodation:
          </h5>
          <p>{{ obj.accommodation }}</p>
        </div>
        <div
          v-if="obj.included_activities[0]"
          class="inclusion-container"
        >
          <h5 class="vtd-font-weight-bold">
            Included Activities:
          </h5>
          <p
            v-for="(activity, index) in obj.included_activities"
            :key="index"
          >
            {{ activity.name }}
          </p>
        </div>
        <div
          v-if="obj.optional_activities[0]"
          class="inclusion-container"
        >
          <h5 class="vtd-font-weight-bold">
            Optional Activities:
          </h5>
          <p
            v-for="(activity, index) in obj.optional_activities"
            :key="index"
          >
            {{ activity.name }}
            <span v-if="activity.price">
              ({{ activity.price }}{{ activity.currency }})</span>
          </p>
        </div>
      </div>
      <h4 class="mt-3 orange">
        Finishing the Trip
      </h4>
      <div
        v-for="(note, index) in trip_data.trip_notes"
        :key="`trip_notes_finish-${index}`"
      >
        <div v-if="note.finish_point">
          <h5 class="mt-3 vtd-font-weight-bold">
            {{ note.finish_point.title }}
          </h5>
          <p
            v-for="(text, index) in note.finish_point.list.text"
            :key="index"
            class="address my-0"
          >
            {{ text }}
          </p>
        </div>
        <div v-if="note.finish_point_description">
          <h5 class="mt-3 vtd-font-weight-bold">
            {{ note.finish_point_description.title }}
          </h5>
          <p class="intrepid-breaks">
            {{ note.finish_point_description.text }}
          </p>
        </div>
        <div v-if="note.finish_point_instructions">
          <h5 class="mt-3 vtd-font-weight-bold">
            {{ note.finish_point_instructions.title }}
          </h5>
          <p class="intrepid-breaks">
            {{ note.finish_point_instructions.text }}
          </p>
        </div>
        <div v-if="note.alt_finish_point">
          <h5 class="mt-3 vtd-font-weight-bold">
            {{ note.alt_finish_point.title }}
          </h5>
          <p
            v-for="(text, index) in note.alt_finish_point.list.text"
            :key="index"
            class="address my-0"
          >
            {{ text }}
          </p>
        </div>
        <div v-if="note.alt_finish_point_instructions">
          <h5 class="mt-3 vtd-font-weight-bold">
            {{ note.alt_finish_point_instructions.title }}
          </h5>
          <p>{{ note.alt_finish_point_instructions.text }}</p>
        </div>
      </div>
      <template>
        <div>
          <h4 class="mt-3 orange">
            Gallery
          </h4>
          <b-carousel
            id="carousel-1"
            v-model="slide"
            :interval="4000"
            controls
            indicators
            background="#ababab"
            img-width="1024"
            img-height="480"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
          >
            <div
              v-for="(image, index) in trip_data.images"
              :key="index"
            >
              <b-carousel-slide
                v-if="image.type === 'gallery'"
                :img-src="image.href"
              />
            </div>
          </b-carousel>
        </div>
      </template>
      <div>
        <h4 class="mt-3 orange">
          Trip Notes
        </h4>
        <div
          v-for="(note, index) in trip_data.trip_notes"
          :key="`trip_notes-${index}`"
        >
          <div v-if="note.physical_preparation">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.physical_preparation.title }}
            </h5>
            <p class="intrepid-breaks">
              {{ note.physical_preparation.text }}
            </p>
          </div>
          <div v-if="note.important_information">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.important_information.title }}
            </h5>
            <p class="intrepid-breaks">
              {{ note.important_information.text }}
            </p>
          </div>
          <div v-if="note.group_leader">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.group_leader.title }}
            </h5>
            <p class="intrepid-breaks">
              {{ note.group_leader.text }}
            </p>
          </div>
          <div v-if="note.safety">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.safety.title }}
            </h5>
            <span v-if="Array.isArray(note.safety.list.text)">
              <p
                v-for="(text, index) in note.safety.list.text"
                :key="index"
                class="my-0 intrepid-breaks"
              >
                {{ text }}
              </p>
            </span>
            <p
              v-else
              class="my-0 intrepid-breaks"
            >
              {{ note.safety.list.text }}
            </p>
          </div>
          <div v-if="note.visas">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.visas.title }}
            </h5>
            <p class="intrepid-breaks">
              {{ note.visas.text }}
            </p>
          </div>
          <div v-if="note.right_for_you">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.right_for_you.title }}
            </h5>
            <p class="intrepid-breaks">
              {{ note.right_for_you.text }}
            </p>
          </div>
          <div v-if="note.health">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.health.title }}
            </h5>
            <p class="intrepid-breaks">
              {{ note.health.text }}
            </p>
          </div>
          <div v-if="note.food_and_dietary">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.food_and_dietary.title }}
            </h5>
            <p class="intrepid-breaks">
              {{ note.food_and_dietary.text }}
            </p>
          </div>
          <div v-if="note.money">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.money.title }}
            </h5>
            <p class="intrepid-breaks">
              {{ note.money.text }}
            </p>
          </div>
          <div v-if="note.packing">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.packing.title }}
            </h5>
            <p
              v-for="(text, index) in note.packing.list.text"
              :key="index"
              class="my-0 intrepid-breaks"
            >
              {{ text }}
            </p>
          </div>
          <div v-if="note.climate">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.climate.title }}
            </h5>
            <p class="intrepid-breaks">
              {{ note.climate.text }}
            </p>
          </div>
          <div v-if="note.rules">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.rules.title }}
            </h5>
            <p>{{ note.rules.text }}</p>
          </div>
          <div v-if="note.emergency_contact">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.emergency_contact.title }}
            </h5>
            <p class="intrepid-breaks">
              {{ note.emergency_contact.text }}
            </p>
          </div>
          <div v-if="note.responsible_travel">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.responsible_travel.title }}
            </h5>
            <p class="intrepid-breaks">
              {{ note.responsible_travel.text }}
            </p>
          </div>
          <div v-if="note.intrepid_foundation">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.intrepid_foundation.title }}
            </h5>
            <p class="intrepid-breaks">
              {{ note.intrepid_foundation.text }}
            </p>
          </div>
          <div v-if="note.accommodation_notes">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.accommodation_notes.title }}
            </h5>
            <p class="intrepid-breaks">
              {{ note.accommodation_notes.text }}
            </p>
          </div>
          <div v-if="note.transport_notes">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.transport_notes.title }}
            </h5>
            <p class="intrepid-breaks">
              {{ note.transport_notes.text }}
            </p>
          </div>
          <div v-if="note.travel_insurance">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.travel_insurance.title }}
            </h5>
            <p class="intrepid-breaks">
              {{ note.travel_insurance.text }}
            </p>
          </div>
          <div v-if="note.fellow_travellers">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.fellow_travellers.title }}
            </h5>
            <p class="intrepid-breaks">
              {{ note.fellow_travellers.text }}
            </p>
          </div>
          <div v-if="note.itinerary_disclaimer">
            <h5 class="mt-3 vtd-font-weight-bold">
              {{ note.itinerary_disclaimer.title }}
            </h5>
            <p class="intrepid-breaks">
              {{ note.itinerary_disclaimer.text }}
            </p>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>

export default {
  props: {
    trip_data: {},
    item: null
  },
  data() {
    return {
      slide: 0,
      sliding: null,
    };
  },
  computed: {
    returnDays() {
      if (
        this.trip_data &&
        this.trip_data.itinerary &&
        Array.isArray(this.trip_data.itinerary)
      ) {
        return this.trip_data.itinerary.length;
      }
      return "";
    },
  },
  methods: {
    show(htlpagelink) {
      this.$refs["intrepid-trip-info-modal-ref"].show();
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
  },
};
</script>

<style scoped>
.intrepid-breaks {
  white-space: break-spaces;
}
.modal-banner-container {
  position: relative;
  text-align: center;
  color: white;
}

.modal-banner-text {
  font-size: 3vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
}

.itinerary-container {
  border: 1px solid black;
  margin-top: 10px;
  padding: 10px;
}

.inclusion-container {
  background-color: #dbdbdb;
  margin: 10px;
  padding: 10px;
}

.address {
  text-indent: 40px;
}

.image-size {
  height: 40vh;
}

.vtd-center-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.vtd-font-weight-bold {
  font-weight: bolder;
}

.orange {
  color: orange;
  font-weight: bolder;
 }
 
</style>